import * as critical from './manifests/0-critical';
import * as farm from './manifests/1-farm';
import * as tractor from './manifests/2-tractor';
import * as pub from './manifests/3-pub';

export const urls = {
  ...critical.urls,
  ...farm.urls,
  ...tractor.urls,
  ...pub.urls,
};

const objectFlip = (obj) => {
  const ret = {};
  Object.keys(obj).forEach((key) => {
    ret[obj[key]] = key;
  });
  return ret;
};

export const ids = objectFlip(urls);

export const fonts = {
  ...critical.fonts,
  ...farm.fonts,
  ...tractor.fonts,
  ...pub.fonts,
};
export const models = {
  ...critical.models,
  ...farm.models,
  ...tractor.models,
  ...pub.models,
};
export const textures = {
  ...critical.textures,
  ...farm.textures,
  ...tractor.textures,
  ...pub.textures,
};
export const sounds = {
  ...critical.sounds,
  ...farm.sounds,
  ...tractor.sounds,
  ...pub.sounds,
};

export const manifests = {
  critical: critical.manifest,
  farm: farm.manifest,
  tractor: tractor.manifest,
  pub: pub.manifest,
};

export {
  //
  critical,
  farm,
  tractor,
  pub,
};

export default {
  critical,
  farm,
  tractor,
  pub,
};
